















import { get, isNil } from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';
import DetailsItem from '@/components/blockbuster/DetailsItem.vue';
import MetadataModel from '@/models/MetadataModel';

@Component({
  components: {
    DetailsItem,
  },
})
export default class Details extends Vue {
  @Prop() metadata?: MetadataModel;
  columns = [
    [
      {
        name: 'Name',
        prop: 's3FileName',
      },
      {
        name: 'Uploaded',
        prop: 'uploadedTimestamp',
      },
      {
        name: 'Recorded',
        prop: 'recordedTimestamp',
      },
      {
        name: 'Share ID',
        prop: 'id',
      },
      {
        name: 'UUID',
        prop: 'uuid',
      },
      {
        name: 'UID',
        prop: 'uid',
      },
      {
        name: 'Model',
        prop: 'model',
      },
      {
        name: 'Shared By',
        prop: 'sharedBy',
      },
      {
        name: 'Tags',
        prop: 'tags',
      },
      { name: 'Notes',
        prop: 'notes'
      },
      {
        name: 'Flagged',
        prop: 'flagged'
      },
      {
        name: 'Reason',
        prop: 'reason',
      }
    ],
  ];

  getValue(property: string): string {
    let p = get(this.metadata, property);
    if (isNil(p)) {
      return 'N/A';
    }
    return p.toString();
  }
}
